import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Users, AlertTriangle, FileText, Gift, Shield } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: BookOpen,
    text: 'Plan completo 30 días (paso a paso)'
  }, {
    icon: Users,
    text: 'Diagnóstico por edad (1–17 años)'
  }, {
    icon: AlertTriangle,
    text: 'Protocolo para berrinches y crisis (en vivo)'
  }, {
    icon: FileText,
    text: 'Plantillas imprimibles: reglas, acuerdo familiar'
  }, {
    icon: Gift,
    text: 'Banco de reemplazos por edad (sin gastar dinero)'
  }, {
    icon: Shield,
    text: 'Plan anti-recaídas para eventos difíciles'
  }];
  return <Section background="cream" data-id="element-98">
      <h2 className="text-2xl font-bold text-[#1e3a5f] mb-6 text-center" data-id="element-99">
        Qué incluye exactamente
      </h2>

      <div className="grid md:grid-cols-2 gap-3" data-id="element-100">
        {items.map((item, i) => <div key={i} className="flex items-start p-3 bg-white rounded-lg shadow-sm border border-gray-100" data-id="element-101">
            <item.icon className="w-5 h-5 text-[#dc4a3d] mr-3 mt-0.5 flex-shrink-0" data-id="element-102" />
            <span className="text-[#2d3748] font-medium text-sm" data-id="element-103">
              {item.text}
            </span>
          </div>)}
      </div>
    </Section>;
}